<div class="sections-container" *ngIf="sections && sections.length > 0">
    <div *ngFor="let section of sections"
        class="section"
        [innerHTML]="section.title"
        (click)="activeModal.close(section)"></div>
</div>
